export const OIL_SP500_INTRO =
  'Oil up can be good (demand/growth) or bad (supply shock). Use 90-day correlation with the ' +
  '3-month oil trend — not correlation alone.';

export const REGIME_MATRIX = [
  {
    corrBand: 'Positive (≥ +0.2)',
    oilUp: { emoji: '🟢', label: 'Growth-driven oil', tooltip: 'Demand lifts oil and stocks.' },
    oilDown: {
      emoji: '🔴',
      label: 'Demand collapse',
      tooltip: 'Recession fear sinks oil and equities.',
    },
  },
  {
    corrBand: 'Negative (≤ −0.2)',
    oilUp: {
      emoji: '🔴',
      label: 'Supply shock',
      tooltip: 'Oil rises without growth — margin and consumer tax.',
    },
    oilDown: { emoji: '🟢', label: 'Supply relief', tooltip: 'Cheaper oil helps stocks.' },
  },
  {
    corrBand: 'Mixed',
    oilUp: { emoji: '🟡', label: 'No clear link', tooltip: 'Weak correlation.' },
    oilDown: { emoji: '🟡', label: 'No clear link', tooltip: 'Weak correlation.' },
  },
];

const POS = 0.2;
const NEG = -0.2;

export function fmtSignedCorr(value) {
  if (value == null || Number.isNaN(value)) return '—';
  const sign = value >= 0 ? '+' : '';
  return `${sign}${value.toFixed(2)}`;
}

export function fmtOil3mPct(logRet) {
  if (logRet == null || Number.isNaN(logRet)) return '—';
  const pct = (Math.exp(logRet) - 1) * 100;
  const sign = pct >= 0 ? '+' : '';
  return `${sign}${pct.toFixed(1)}%`;
}

export function oilRegime(corr90, oil3mLogRet) {
  if (corr90 == null || oil3mLogRet == null || Number.isNaN(corr90)) {
    return { id: 'unknown', label: '—', emoji: '', cssClass: 'neutral', tooltip: '' };
  }
  const up = oil3mLogRet > 0;
  if (corr90 >= POS) {
    const row = up ? REGIME_MATRIX[0].oilUp : REGIME_MATRIX[0].oilDown;
    return {
      ...row,
      id: up ? 'growth_driven' : 'demand_collapse',
      cssClass: up ? 'growth' : 'stress',
    };
  }
  if (corr90 <= NEG) {
    const row = up ? REGIME_MATRIX[1].oilUp : REGIME_MATRIX[1].oilDown;
    return {
      ...row,
      id: up ? 'supply_shock' : 'supply_relief',
      cssClass: up ? 'stress' : 'growth',
    };
  }
  return { ...REGIME_MATRIX[2].oilUp, id: 'unclear', cssClass: 'mixed' };
}

export function situationAtPoint(c30, c60, c90, oil3mLogRet) {
  const reg = oilRegime(c90, oil3mLogRet);
  const oilPct = fmtOil3mPct(oil3mLogRet);
  const headline =
    reg.id === 'unknown'
      ? 'Regime unclear.'
      : `${reg.emoji} ${reg.label} — oil 3m ${oilPct}`;
  const detail = `30d ${fmtSignedCorr(c30)}; 60d ${fmtSignedCorr(c60)}; 90d ${fmtSignedCorr(
    c90,
  )}. Oil 3m ${oilPct}. ${reg.tooltip || ''}`;
  return { headline, detail, reg, primaryCss: reg.cssClass };
}

export function pickCorr(bars, time) {
  return bars?.find((b) => b.time === time)?.value ?? null;
}
